export default __webpack_public_path__ + "static/media/newLiveChatSound.540c06eb.mp3";